import { render } from "./BusinessServicePage.vue?vue&type=template&id=9fb1fe3a"
import script from "./BusinessServicePage.vue?vue&type=script&lang=js"
export * from "./BusinessServicePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__